import { render } from "./AlergyPerson.vue?vue&type=template&id=5711bb70&ts=true"
import script from "./AlergyPerson.vue?vue&type=script&lang=ts"
export * from "./AlergyPerson.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\wamp64\\www\\hayllissac\\sistema\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__